//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { workOrderDeleteWorkOrder, reset } from "./redux/slice";

const DeleteWorkOrder = ({ refresh, single }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, workOrder, workOrderList } = useSelector((state) => state.workOrdersDeleteWorkOrderRedux);

    const workOrderListDetails = workOrderList?.filter((item) => item?.recordType === 'DETAIL')

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteWorkOrders_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = workOrder
                ? messages['manage_deleteWorkOrder_successMessage']
                : messages['manage_deleteWorkOrders_successMessage'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh && refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={workOrder ? single ? `${messages['manage_deleteWorkOrder_title']} ${workOrder?.name ? ` "${workOrder?.name}"` : ''}` : messages['manage_deleteWorkOrder_title'] : messages['manage_deleteWorkOrders_title']}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => {
                            if (workOrder) {
                                dispatch(workOrderDeleteWorkOrder({ ids: [workOrder?.id] }));
                            }
                            if (workOrderListDetails?.length) {
                                let ids = workOrderListDetails.map((item) => item?.id)
                                dispatch(workOrderDeleteWorkOrder({ ids: ids }));
                            }
                        }}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{workOrder ? messages['manage_deleteWorkOrder_description'] : messages['manage_deleteWorkOrders_description']}</p>
                {
                    !single && (
                        <ul>
                            {workOrder ? (
                                <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                    {workOrder?.workOrderNumber}
                                </li>
                            ) : (
                                workOrderListDetails?.map((item, index) => (
                                    <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                        {item.workOrderNumber}
                                    </li>
                                ))
                            )}
                        </ul>
                    )
                }
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteWorkOrder;